import { TextField } from '@mui/material';
import { AddUserFormValues } from '@src/hooks/api/mutations/useUserCreate';
import { useFormContext } from 'react-hook-form';
import useAlias from '@alias';

function PasswordField() {
  const alias = useAlias();
  const {
    register,
    formState: { errors },
  } = useFormContext<AddUserFormValues>();

  return (
    <TextField
      fullWidth
      label={alias('Temporary Password')}
      {...register('password')}
      error={!!errors.password}
      helperText={errors.password?.message}
      type='password'
      size='small'
      autoComplete='off'
    />
  );
}

export default PasswordField;
